// extracted by mini-css-extract-plugin
module.exports = {"container":"LogoLoader_container__2-N5t"};